/**
 * Kaysou Assist — estado puro do tablet de sala.
 *
 * Sem I/O: recebe a lista vinda do servidor (REST ou WebSocket) e decide
 * o que fica visível, com que cor e há quanto tempo espera.
 */

export const ASSIST_STATUS = { NEW: "new", ACCEPTED: "accepted", COMPLETED: "completed" };

/** Quanto tempo um chamado concluído fica verde no ecrã antes de ir para histórico. */
export const COMPLETED_VISIBLE_MS = 6000;
export const PAID_VISIBLE_MS = 30000;

export const TYPE_LABELS = {
  waiter: "Llamar camarero",
  bill: "Pedir la cuenta",
};

export const STATUS_LABELS = {
  new: "Esperando",
  accepted: "En camino",
  completed: "Atendido",
};

/** Insere ou substitui um chamado, mantendo a ordem por antiguidade. */
export function mergeRequest(list, request) {
  if (!request?.id) return list;
  const next = list.some((r) => r.id === request.id)
    ? list.map((r) => (r.id === request.id ? request : r))
    : [...list, request];
  return next.sort((a, b) => String(a.created_at || "").localeCompare(String(b.created_at || "")));
}

function completedAtMs(request) {
  const value = request?.completed_at;
  if (!value) return 0;
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? 0 : ms;
}

/** Ativos sempre; concluídos apenas durante alguns segundos. */
export function visibleRequests(list, nowMs, completedVisibleMs = COMPLETED_VISIBLE_MS) {
  return (list || []).filter((r) => {
    if (r?.status === ASSIST_STATUS.NEW || r?.status === ASSIST_STATUS.ACCEPTED) return true;
    if (r?.status !== ASSIST_STATUS.COMPLETED) return false;
    const done = completedAtMs(r);
    const visibleMs = r?.payment_status === "paid" ? PAID_VISIBLE_MS : completedVisibleMs;
    return done > 0 && nowMs - done < visibleMs;
  });
}

/** Quantos chamados novos existem na lista (dirige o alerta sonoro único). */
export function countNew(list) {
  return (list || []).filter((r) => r?.status === ASSIST_STATUS.NEW).length;
}

/** Tempo de espera formatado m:ss a partir de created_at. */
export function formatWaiting(createdAt, nowMs) {
  const started = new Date(createdAt).getTime();
  if (!createdAt || Number.isNaN(started)) return "0:00";
  const seconds = Math.max(0, Math.floor((nowMs - started) / 1000));
  const mins = Math.floor(seconds / 60);
  return `${mins}:${String(seconds % 60).padStart(2, "0")}`;
}
